import type { AhPayload, AhTotals } from '../ahReport';
import { fmtNum } from '../utils';
import campaignVisual from '../assets/campaign-visual.png';

type Campaign = AhPayload['campaign'];

export function Hero({ campaign, totals }: { campaign: Campaign; totals: AhTotals }) {
  return (
    <section className="hero hero-with-visual">
      <div className="hero-left">
        <div>
          <div className="hero-eyebrow">
            <span className="pill">LIVE</span>
            <span>
              Campagne dag {campaign.currentDay} van {campaign.totalDays} · Periode {campaign.currentPeriod}
            </span>
          </div>
        </div>
        <div className="hero-meta">
          <div className="hero-meta-row">
            <div>
              <span className="k">Start</span>
              <span className="v">{campaign.start}</span>
            </div>
            <div>
              <span className="k">Einde</span>
              <span className="v">{campaign.end}</span>
            </div>
            <div>
              <span className="k">Status</span>
              <span className="v">In voortgang</span>
            </div>
          </div>
          <div className="hero-meta-row">
            <div>
              <span className="k">Tempo</span>
              <span className="v">~{fmtNum(Math.round(totals.gameplays / campaign.currentDay))} spellen / dag</span>
            </div>
          </div>
        </div>
      </div>
      <img className="hero-visual" src={campaignVisual} alt={`Campagne visual — ${campaign.name}`} />
    </section>
  );
}
